export default {
  firstDate: null,
  lastDate: null,
  engagementId: null,
  engagementTypeId: null,
  isSummary: false,
  attributions: null,
  engagement: null,
  timezone: null,
  isLoading: true,
};
